import Vue from 'vue';
// import '@babel/polyfill';
import menus from '@constants/menu';
import _ from 'lodash';
import axios from 'axios';

import '@assets/styles/default.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@assets/styles/theme.less';
import '@assets/styles/iconfont.css';
import '@assets/styles/cw-common.less';

import '@components/core/registerComponent';
import '@components/core/registerAjax';
import '@components/core/registerDirective';
import '@components/core/registerFilter';
import '@components/core/chart';
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

import moment from 'moment';
moment.locale('zh-cn');
Vue.prototype.$moment = moment;

//在应用启动时，可以通过设置 Vue.config.productionTip = false 来关闭生产模式下给出的提示
Vue.config.productionTip = false;
window.ssid = getCookie('SSID');

import App from './App.vue';
import router from './router';
import store from './store';
import getCookie from "@util/getCookie";//获取cookie里的SSID

global.vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
});

router.afterEach((to, from) => {
  //灵犀埋点
  var meta = to.meta;
  var valLab = {
    custom: {
      hotel_id: store.state.userInfo.hotelId || -1,
      agency_id: store.state.userInfo.agencyId || -1,
    }
  };

  if (meta.cid) {
    setTimeout(() => {
      LXAnalytics && LXAnalytics('pageView', valLab, null, meta.cid);
    }, 100);
  }
  // 统计代码
  if (from.name) {
    _hmt.push(['_trackPageview'
      , '/#' + to.fullPath
      , window.location.origin ]);
  } else {
    _hmt.push(['_trackPageview'
      , '/#' + to.fullPath]);
  }
  // console.log(_hmt);
  if (document.querySelector('.content-wrapper')) {
    document.querySelector('.content-wrapper').scrollTop = 0;
  }
});

router.beforeEach((to, from, next) => {
  // 解决三级菜单tabs 权限不足进入页面异常问题
  let path = to.path,
      targetTabs = [],
      targetRouter = null,
      last = path.substr(path.length-1,1);
  if (last === '/') {
    path = path.substr(0, path.length-1);
  }
  _.forEach(menus, menu => {
    _.forEach(menu.children, child => {
      if (child.children) {
        let find = _.find(child.children, item => {
          return item.path === path;
        });
        if (find) {
          targetTabs = child.children;
          targetRouter = find;
        }
      }
    });
  });
  let menuList = JSON.parse(localStorage.menuList);
  let crmMenu = [];
  if (menuList) {
    crmMenu = menuList.crm || [];
    menuList.sys = menuList.sys || [];
    crmMenu = crmMenu.concat(menuList.sys);
  }
  let tabList = [];
  _.forEach(targetTabs, item => {
    if (crmMenu.indexOf(+item.id) >= 0) {
      tabList.push(item);
    }
  });

  let find = _.find(tabList, tab => {
    return tab.path === targetRouter.path;
  });
  if (find) {
    next();
  } else if (!targetTabs.length) {
    next();
  } else {
    next(tabList[0].path);
  }
});



// WEBPACK FOOTER //
// ./src/index.js